<template>
  <div class="generic-page">
    <Header />
    
    <main class="page-content">
      <div class="container">
        <h1 v-if="data.pageTitle">{{ data.pageTitle }}</h1>
        <div v-if="data.pageContent" v-html="data.pageContent" class="page-body"></div>
        
        <!-- Render any additional components based on page properties -->
        <component 
          v-for="(component, index) in pageComponents" 
          :key="index"
          :is="component.name"
          :content="component.data"
        />
      </div>
    </main>
    
    <Footer :content="data.footer" />
  </div>
</template>

<script>
import Header from '../Header/Header.vue'
import Footer from '../Footer.vue'

export default {
  name: 'GenericPage',
  components: {
    Header,
    Footer
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    pageComponents() {
      // Parse page data for additional components
      const components = []
      
      if (this.data.carousel) {
        components.push({ name: 'Carousel', data: this.data.carousel })
      }
      
      if (this.data.gallery) {
        components.push({ name: 'Gallery', data: this.data.gallery })
      }
      
      return components
    }
  }
}
</script>

<style scoped>
.generic-page {
  min-height: 100vh;
}

.page-content {
  padding: 2rem 0;
  min-height: 50vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.page-body {
  line-height: 1.6;
}

.page-body h1,
.page-body h2,
.page-body h3 {
  margin-top: 2rem;
  margin-bottom: 1rem;
}

.page-body p {
  margin-bottom: 1rem;
}
</style>
